import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  title: 'Recuperar tiempo',
  description: 'Menos rutina de maquillaje mañana a mañana.'
}, {
  title: 'Ganar confianza',
  description: 'Salir sin make-up y sentirte igual de segura.'
}, {
  title: 'Reconocerte',
  description: "Ver tu reflejo y pensar 'sí, esta soy yo'."
}, {
  title: 'Libertad',
  description: 'Al mar, al gym, a la reunión. Siempre lista. Siempre vos.'
}, {
  title: 'Inversión inteligente',
  description: 'Un resultado que dura meses vs. productos que se repiten cada semana.'
}];
export function BenefitsSection() {
  return <section className="w-full py-24 relative overflow-hidden" data-id="element-43">
      {/* Marble Background */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rL7dK7UH3wwQa67MzLqofL/textura-de-marmol-blanco-y-dorado-natural-para-tapiceria-tela-piel-fondo-lujo-interiores-paredes-arte-ceramica-piedra-creativa-268157195.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-44"></div>
      <div className="absolute inset-0 vignette-overlay pointer-events-none" data-id="element-45"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-46">
        {/* Header in translucent card */}
        <div className="text-center mb-16" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="inline-block rounded-2xl px-10 py-8" style={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(16px) saturate(180%)',
          WebkitBackdropFilter: 'blur(16px) saturate(180%)',
          border: '1px solid rgba(212, 175, 55, 0.2)'
        }} data-id="element-48">
            <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A] mb-4" data-id="element-49">
              Resultados
            </h2>
            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810] mb-6" data-id="element-50">
              Lo que cambia en tu vida
            </h3>
            <p className="text-[#7A5C4F] font-light max-w-2xl mx-auto text-lg" data-id="element-51">
              Esto no se trata solo de "verte linda". Se trata de:
            </p>
          </motion.div>
        </div>

        <div className="flex flex-col gap-6 max-w-2xl mx-auto" data-id="element-52">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.12
        }} className="flex items-start gap-6 rounded-2xl p-6 md:p-8" style={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(16px) saturate(180%)',
          WebkitBackdropFilter: 'blur(16px) saturate(180%)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.04)'
        }} data-id="element-53">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white/80 flex items-center justify-center border border-[#D4AF37]/30" data-id="element-54">
                <svg className="w-5 h-5 text-[#C9956A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-55">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" data-id="element-56" />
                </svg>
              </div>
              <div data-id="element-57">
                <h4 className="font-serif text-2xl text-[#2C1810] mb-2" data-id="element-58">
                  {benefit.title}
                </h4>
                <p className="text-[#5C3D2E] font-light leading-relaxed" data-id="element-59">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}